import React, {Proptypes} from 'react';
// import './signup.less';
import './forgot-password.less';
import {Link, browserHistory} from 'react-router';
import ResponsiveHeader from '../header/responsive_header';
const MediaQuery = require('react-responsive');
import authActions from './auth_actions';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {routerActions} from 'react-router-redux';
import validate from '../util/validate';
import ShowError from '../components/error/show_error';
import SuccessMessage from '../components/success/success_msg.jsx';
import {join} from '../util/common';

class ForgotPassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            ajaxInProgress: false,
            validationError: '',
            error: '',
            success: ''
        }
        this.resetPassword = this.resetPassword.bind(this);
        this.inputChange = this.inputChange.bind(this);
    }

    resetPassword(e) {
        e.preventDefault();

        const self = this;
        const {props, state} = this;
        let {email, ajaxInProgress} = state;

        let validationErrorMsg = '';

        const validationError = {
            email: !validate.email(email)
        };

        const validationMap = {
            email: 'Email'
        };

        const validationFields = [];

        Object.keys(validationError).forEach((key) => {
            if (validationError[key]) {
                validationFields.push(validationMap[key]);
            }
        });

        if (validationFields.length) {
            validationErrorMsg = 'Please enter valid ' + join(validationFields, (item, idx) => {
                if (validationFields.length === 1)
                    return "";
                if (idx > 0 && idx < validationFields.length - 1)
                    return ", ";
                else if (idx === validationFields.length - 1)
                    return " and ";
                return "";
            }) + '.';
        }

        if (validationErrorMsg) {
            this.setState({error: validationErrorMsg});
            return;
        }
        this.setState({ajaxInProgress: true});
        props.actions.resetPassword(email).then((data) => {
            this.setState({ajaxInProgress: false,
              success: 'Reset password link sent'
            });
            setTimeout(() => {
              this.setState({
                ajaxInProgress: false,
                success: ''
              });
              browserHistory.push('/login');
            }, 3000);

        }, (error) => {
            this.setState({ajaxInProgress: false,
                              error : error.error});
        })

    }

    inputChange(name, event) {
        const stateObj = {};
        stateObj[name] = event.target.value;
        this.setState(stateObj);
    }

    render() {

        const self = this;
        const {props, state} = self;
        const {authState, actions} = props;
        const {email, ajaxInProgress} = state;
        const loader = <div className="loader"></div>;

        let errorMsg = '';
        let successMsg = '';

        if(state.error){
          errorMsg = state.error;
        }

        state.success ? successMsg = state.success : successMsg = '';

        return (
            <div className="forgotpassword-page">
                <MediaQuery query='(max-width: 767px)'>
                    <ResponsiveHeader logoImagePath="../public/images/landing/logo_white_saffron.png" iconClassName="user-auth-menu-icon  icon-three-bars" responsiveHeaderClassName="user-auth-default-header"/>
                </MediaQuery>
                <MediaQuery query='(min-width: 768px)'>
                  <Link to="/">
                    <div className="awb-logo-wrp"></div>
                  </Link>
                </MediaQuery>
                <div className="forgot-password-wrapper">
                  {state.error && <ShowError errorMessage = {errorMsg} />}
                  {state.success && <SuccessMessage successMessage = {successMsg} />}
                    <div className="forgot-password-img"></div>
                    <div className="forgot-form-wrap">
                        <h1 className="page-header text-align-center">Forgot Password</h1>
                        <form className="user-auth-form">
                            <div className="forgotpassword-form-wrp">
                                <span className="icon-email ic-image"></span>
                                <input placeholder="Email" className="form-input" type="text" autoCapitalize="none" name="email" onChange={this.inputChange.bind(self, 'email')}/>
                            </div>
                            <div className="form-btn-wrap">
                                <button className="btn orange" onClick={this.resetPassword}>{ajaxInProgress? loader : 'Reset Password'}</button>
                            </div>
                            <div className="forgot-password-nav-wrap">
                              Return to<Link className="nav-link" to="/login">&nbsp;Login</Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(authActions, dispatch),
        routerActions: bindActionCreators(routerActions, dispatch)
    }
}

ForgotPassword = connect(mapDispatchToProps, mapDispatchToProps)(ForgotPassword);
export default ForgotPassword;



// WEBPACK FOOTER //
// app/auth/forgot_password.jsx